/**
 |--------------------------------------------------------------------------
 | CLIENTS : Vue-Router Routes
 |--------------------------------------------------------------------------
 */
const clients = [
 {
  path: '/clients/all/active', component: require('pages/companies/all_active.vue').default,
  name: 'all_active_clients',
  meta: {requiresAuth: true, title: "All Active Clients", icon: "fas fa-running"}
 }, {
  path: '/clients/all/lapsed', component: require('pages/companies/all_lapsed.vue').default,
  name: 'all_lapsed_clients',
  meta: {requiresAuth: true, title: "All Lapsed Clients", icon: "fas fa-bed"}
 },
];
export default clients;
